import { CssBaseline } from '@mui/material';
import { APIProvider } from '@vis.gl/react-google-maps';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter as Router } from 'react-router-dom';
import { SitesProvider } from '../views/order-feed/context/sites-context'; // separate into local context, not global context
import { PondsProvider } from '../views/production-systems/context/ponds-context';
import { AccountProvider } from './account/account-context';
import { ChartSettingsProvider } from './chart/chart-settings-context';
import { LanguageProvider } from './language/language-context';
import { LocaleProvider } from './locale/locale-context';
import { ThemeContextProvider } from './theme/ThemeContext';
import AppErrorBoundary from 'contexts/error-handler/app-error-boundary';

type ProviderWrapperProps = {
  children: React.ReactNode;
  queryClient: QueryClient;
};

const ProviderWrapper: React.FC<ProviderWrapperProps> = ({ queryClient, children }) => {
  return (
    <ThemeContextProvider>
      <ChartSettingsProvider>
        <LanguageProvider>
          <AppErrorBoundary>
            <CssBaseline />
            <LocaleProvider>
              <QueryClientProvider client={queryClient}>
                <APIProvider apiKey={import.meta.env.VITE_GOOGLE_MAPS_TOKEN}>
                  <PondsProvider>
                    <Router>
                      <AccountProvider>
                        <SitesProvider>{children}</SitesProvider>
                      </AccountProvider>
                    </Router>
                  </PondsProvider>
                </APIProvider>
              </QueryClientProvider>
            </LocaleProvider>
          </AppErrorBoundary>
        </LanguageProvider>
      </ChartSettingsProvider>
    </ThemeContextProvider>
  );
};

export default ProviderWrapper;
